import { Button, Breadcrumb, Popconfirm, Space, Switch, Table, Tag } from "antd";
import { EditOutlined, HomeOutlined, PlusOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { openNotification } from "../../../components/Notification";
import PageHeader from "../../../components/PageHeader";
import { SecaoCard } from "../../../components/SecaoCard";
import { UserContext } from "../../../contexts/UserContext";
import { menuIndicadorService } from "../../../services/resources/menuIndicadorService";
import { podeGerenciarMenuIndicador, urls } from "../../../utils";

function comChildren(nos) {
  return (nos || []).map((no) => ({
    ...no,
    children: no.filhos?.length ? comChildren(no.filhos) : undefined,
  }));
}

export const ListagemMenuIndicador = () => {
  const history = useHistory();
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const autorizado = podeGerenciarMenuIndicador(user);

  useEffect(() => {
    if (autorizado) carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autorizado]);

  async function carregar() {
    setLoading(true);
    try {
      const { data } = await menuIndicadorService.listarAdmin();
      setDados(comChildren(data));
    } catch (error) {
      openNotification(
        "error",
        <strong>Erro ao listar menus</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  async function alternarAtivo(record, ativo) {
    try {
      if (ativo) {
        await menuIndicadorService.ativar(record.codigo);
      } else {
        await menuIndicadorService.desativar(record.codigo);
      }
      openNotification("success", <strong>Situação atualizada</strong>);
      carregar();
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível alterar a situação</strong>,
        error?.response?.data?.userMessage
      );
    }
  }

  const columns = [
    { title: <strong>nome</strong>, dataIndex: "nome", key: "nome" },
    {
      title: <strong>tipo</strong>,
      key: "tipo",
      render: (record) => (record.url ? "Link" : "Pasta"),
    },
    {
      title: <strong>permissão</strong>,
      dataIndex: "permissaoNome",
      render: (value) => value || "-",
    },
    {
      title: <strong>grupos</strong>,
      key: "grupos",
      render: (record) =>
        record.grupos?.length
          ? record.grupos.map((grupo) => grupo.nome).join(", ")
          : "-",
    },
    {
      title: <strong>situação</strong>,
      dataIndex: "ativo",
      render: (ativo, record) => (
        <Popconfirm
          title={ativo ? "Desativar este item?" : "Ativar este item?"}
          onConfirm={() => alternarAtivo(record, !ativo)}
          okText="Sim"
          cancelText="Não"
        >
          <Switch checked={ativo} checkedChildren="ativo" unCheckedChildren="inativo" />
        </Popconfirm>
      ),
    },
    {
      title: <strong>ações</strong>,
      key: "acoes",
      width: 90,
      render: (record) => (
        <Space>
          <Button
            type="primary"
            ghost
            className="action-button"
            title="Editar"
            onClick={() =>
              history.push(
                urls.MENUS_INDICADORES_EDITAR.replace(":codigo", record.codigo)
              )
            }
          >
            <EditOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  if (!autorizado) {
    return (
      <div id="sectionMain">
        <Tag color="red">Acesso restrito ao grupo OISOL MASTER</Tag>
      </div>
    );
  }

  return (
    <div id="sectionMain">
      <Breadcrumb id="breadcrumb">
        <Breadcrumb.Item>
          <Link to="">
            <HomeOutlined />
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>gerenciamento</Breadcrumb.Item>
        <Breadcrumb.Item>
          <strong>menus de indicadores</strong>
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="container-section">
        <PageHeader
          titulo="MENUS DE INDICADORES"
          extra={[
            <Link to={urls.MENUS_INDICADORES_CRIAR} key="novo">
              <Button type="primary" icon={<PlusOutlined />}>
                novo item
              </Button>
            </Link>,
          ]}
        />
        <SecaoCard>
        <Table
          rowKey="codigo"
          loading={loading}
          columns={columns}
          dataSource={dados}
          pagination={false}
          defaultExpandAllRows
        />
        </SecaoCard>
      </div>
    </div>
  );
};
